/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserInfo } from "../../models/user";

export enum SignedInState {
  Unset = "Unset",
  SignedIn = "SignedIn",
  SignedOut = "SignedOut",
}

export const getSignInState = (state: any): SignedInState => {
  const auth = state.auth;
  if (!auth.isFetched) {
    return SignedInState.Unset;
  }

  return auth.userInfo ? SignedInState.SignedIn : SignedInState.SignedOut;
};

export const getIsUserSignedIn = (state: any): boolean => (state?.auth?.userInfo ? true : false);

export const getUser = (state: any): UserInfo | undefined => state.auth?.userInfo;
